import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Profile Details")
  ])
], -1)
const _hoisted_3 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "row mb-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Avatar", -1)
const _hoisted_7 = { class: "col-lg-8" }
const _hoisted_8 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true",
  style: {"background-image":"url(media/avatars/blank.png)"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "\n                    btn btn-icon btn-circle btn-active-color-primary\n                    w-25px\n                    h-25px\n                    bg-white\n                    shadow\n                  ",
  "data-kt-image-input-action": "change",
  "data-bs-toggle": "tooltip",
  title: "Change avatar"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-fill fs-7" }),
  /*#__PURE__*/_createElementVNode("input", {
    type: "file",
    name: "avatar",
    accept: ".png, .jpg, .jpeg"
  }),
  /*#__PURE__*/_createElementVNode("input", {
    type: "hidden",
    name: "avatar_remove"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, "Allowed file types: png, jpg, jpeg.", -1)
const _hoisted_13 = { class: "row mb-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Full Name", -1)
const _hoisted_15 = { class: "col-lg-8" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-lg-6 fv-row" }
const _hoisted_18 = { class: "fv-plugins-message-container" }
const _hoisted_19 = { class: "fv-help-block" }
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = { class: "fv-plugins-message-container" }
const _hoisted_22 = { class: "fv-help-block" }
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Company", -1)
const _hoisted_25 = { class: "col-lg-8 fv-row" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Contact Phone"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Phone number must be active"
  })
], -1)
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { class: "fv-plugins-message-container" }
const _hoisted_32 = { class: "fv-help-block" }
const _hoisted_33 = { class: "row mb-6" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Company Site", -1)
const _hoisted_35 = { class: "col-lg-8 fv-row" }
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Country"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-1 fs-7",
    "data-bs-toggle": "tooltip",
    title: "Country of origination"
  })
], -1)
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", { value: "AF" }, "Afghanistan", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "AX" }, "Aland Islands", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "AL" }, "Albania", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "DZ" }, "Algeria", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("option", { value: "AS" }, "American Samoa", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("option", { value: "AD" }, "Andorra", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "AO" }, "Angola", -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "AI" }, "Anguilla", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "AQ" }, "Antarctica", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "AG" }, "Antigua and Barbuda", -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("option", { value: "AR" }, "Argentina", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: "AM" }, "Armenia", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("option", { value: "AW" }, "Aruba", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "AU" }, "Australia", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", { value: "AT" }, "Austria", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "AZ" }, "Azerbaijan", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "BS" }, "Bahamas", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "BH" }, "Bahrain", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "BD" }, "Bangladesh", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "BB" }, "Barbados", -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("option", { value: "BY" }, "Belarus", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("option", { value: "BE" }, "Belgium", -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("option", { value: "BZ" }, "Belize", -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("option", { value: "BJ" }, "Benin", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "BM" }, "Bermuda", -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("option", { value: "BT" }, "Bhutan", -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("option", { value: "BO" }, "Bolivia, Plurinational State of", -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", { value: "BQ" }, "Bonaire, Sint Eustatius and Saba", -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("option", { value: "BA" }, "Bosnia and Herzegovina", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("option", { value: "BW" }, "Botswana", -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("option", { value: "BV" }, "Bouvet Island", -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", { value: "BR" }, "Brazil", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", { value: "IO" }, "British Indian Ocean Territory", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: "BN" }, "Brunei Darussalam", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("option", { value: "BG" }, "Bulgaria", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("option", { value: "BF" }, "Burkina Faso", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("option", { value: "BI" }, "Burundi", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("option", { value: "KH" }, "Cambodia", -1)
const _hoisted_79 = /*#__PURE__*/_createElementVNode("option", { value: "CM" }, "Cameroon", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("option", { value: "CA" }, "Canada", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("option", { value: "CV" }, "Cape Verde", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("option", { value: "KY" }, "Cayman Islands", -1)
const _hoisted_83 = /*#__PURE__*/_createElementVNode("option", { value: "CF" }, "Central African Republic", -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("option", { value: "TD" }, "Chad", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("option", { value: "CL" }, "Chile", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("option", { value: "CN" }, "China", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("option", { value: "CX" }, "Christmas Island", -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("option", { value: "CC" }, "Cocos (Keeling) Islands", -1)
const _hoisted_89 = /*#__PURE__*/_createElementVNode("option", { value: "CO" }, "Colombia", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("option", { value: "KM" }, "Comoros", -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("option", { value: "CG" }, "Congo", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("option", { value: "CD" }, " Congo, the Democratic Republic of the ", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("option", { value: "CK" }, "Cook Islands", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("option", { value: "CR" }, "Costa Rica", -1)
const _hoisted_95 = /*#__PURE__*/_createElementVNode("option", { value: "CI" }, "Côte d'Ivoire", -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("option", { value: "HR" }, "Croatia", -1)
const _hoisted_97 = /*#__PURE__*/_createElementVNode("option", { value: "CU" }, "Cuba", -1)
const _hoisted_98 = /*#__PURE__*/_createElementVNode("option", { value: "CW" }, "Curaçao", -1)
const _hoisted_99 = /*#__PURE__*/_createElementVNode("option", { value: "CY" }, "Cyprus", -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("option", { value: "CZ" }, "Czech Republic", -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("option", { value: "DK" }, "Denmark", -1)
const _hoisted_102 = /*#__PURE__*/_createElementVNode("option", { value: "DJ" }, "Djibouti", -1)
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: "DM" }, "Dominica", -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("option", { value: "DO" }, "Dominican Republic", -1)
const _hoisted_105 = /*#__PURE__*/_createElementVNode("option", { value: "EC" }, "Ecuador", -1)
const _hoisted_106 = /*#__PURE__*/_createElementVNode("option", { value: "EG" }, "Egypt", -1)
const _hoisted_107 = /*#__PURE__*/_createElementVNode("option", { value: "SV" }, "El Salvador", -1)
const _hoisted_108 = /*#__PURE__*/_createElementVNode("option", { value: "GQ" }, "Equatorial Guinea", -1)
const _hoisted_109 = /*#__PURE__*/_createElementVNode("option", { value: "ER" }, "Eritrea", -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("option", { value: "EE" }, "Estonia", -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "ET" }, "Ethiopia", -1)
const _hoisted_112 = /*#__PURE__*/_createElementVNode("option", { value: "FK" }, "Falkland Islands (Malvinas)", -1)
const _hoisted_113 = /*#__PURE__*/_createElementVNode("option", { value: "FO" }, "Faroe Islands", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("option", { value: "FJ" }, "Fiji", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("option", { value: "FI" }, "Finland", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("option", { value: "FR" }, "France", -1)
const _hoisted_117 = /*#__PURE__*/_createElementVNode("option", { value: "GF" }, "French Guiana", -1)
const _hoisted_118 = /*#__PURE__*/_createElementVNode("option", { value: "PF" }, "French Polynesia", -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("option", { value: "TF" }, "French Southern Territories", -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("option", { value: "GA" }, "Gabon", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("option", { value: "GM" }, "Gambia", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("option", { value: "GE" }, "Georgia", -1)
const _hoisted_123 = /*#__PURE__*/_createElementVNode("option", { value: "DE" }, "Germany", -1)
const _hoisted_124 = /*#__PURE__*/_createElementVNode("option", { value: "GH" }, "Ghana", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("option", { value: "GI" }, "Gibraltar", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("option", { value: "GR" }, "Greece", -1)
const _hoisted_127 = /*#__PURE__*/_createElementVNode("option", { value: "GL" }, "Greenland", -1)
const _hoisted_128 = /*#__PURE__*/_createElementVNode("option", { value: "GD" }, "Grenada", -1)
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "GP" }, "Guadeloupe", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("option", { value: "GU" }, "Guam", -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("option", { value: "GT" }, "Guatemala", -1)
const _hoisted_132 = /*#__PURE__*/_createElementVNode("option", { value: "GG" }, "Guernsey", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("option", { value: "GN" }, "Guinea", -1)
const _hoisted_134 = /*#__PURE__*/_createElementVNode("option", { value: "GW" }, "Guinea-Bissau", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("option", { value: "GY" }, "Guyana", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("option", { value: "HT" }, "Haiti", -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("option", { value: "HM" }, "Heard Island and McDonald Islands", -1)
const _hoisted_138 = /*#__PURE__*/_createElementVNode("option", { value: "VA" }, "Holy See (Vatican City State)", -1)
const _hoisted_139 = /*#__PURE__*/_createElementVNode("option", { value: "HN" }, "Honduras", -1)
const _hoisted_140 = /*#__PURE__*/_createElementVNode("option", { value: "HK" }, "Hong Kong", -1)
const _hoisted_141 = /*#__PURE__*/_createElementVNode("option", { value: "HU" }, "Hungary", -1)
const _hoisted_142 = /*#__PURE__*/_createElementVNode("option", { value: "IS" }, "Iceland", -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("option", { value: "IN" }, "India", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", { value: "ID" }, "Indonesia", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: "IR" }, "Iran, Islamic Republic of", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: "IQ" }, "Iraq", -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("option", { value: "IE" }, "Ireland", -1)
const _hoisted_148 = /*#__PURE__*/_createElementVNode("option", { value: "IM" }, "Isle of Man", -1)
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", { value: "IL" }, "Israel", -1)
const _hoisted_150 = /*#__PURE__*/_createElementVNode("option", { value: "IT" }, "Italy", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("option", { value: "JM" }, "Jamaica", -1)
const _hoisted_152 = /*#__PURE__*/_createElementVNode("option", { value: "JP" }, "Japan", -1)
const _hoisted_153 = /*#__PURE__*/_createElementVNode("option", { value: "JE" }, "Jersey", -1)
const _hoisted_154 = /*#__PURE__*/_createElementVNode("option", { value: "JO" }, "Jordan", -1)
const _hoisted_155 = /*#__PURE__*/_createElementVNode("option", { value: "KZ" }, "Kazakhstan", -1)
const _hoisted_156 = /*#__PURE__*/_createElementVNode("option", { value: "KE" }, "Kenya", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("option", { ue: "KI" }, "Kiribati", -1)
const _hoisted_158 = /*#__PURE__*/_createElementVNode("option", { value: "KP" }, " Korea, Democratic People's Republic of ", -1)
const _hoisted_159 = /*#__PURE__*/_createElementVNode("option", { value: "KW" }, "Kuwait", -1)
const _hoisted_160 = /*#__PURE__*/_createElementVNode("option", { value: "KG" }, "Kyrgyzstan", -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("option", { value: "LA" }, "Lao People's Democratic Republic", -1)
const _hoisted_162 = /*#__PURE__*/_createElementVNode("option", { value: "LV" }, "Latvia", -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("option", { value: "LB" }, "Lebanon", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", { value: "LS" }, "Lesotho", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: "LR" }, "Liberia", -1)
const _hoisted_166 = /*#__PURE__*/_createElementVNode("option", { value: "LY" }, "Libya", -1)
const _hoisted_167 = /*#__PURE__*/_createElementVNode("option", { value: "LI" }, "Liechtenstein", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("option", { value: "LT" }, "Lithuania", -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("option", { value: "LU" }, "Luxembourg", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("option", { value: "MO" }, "Macao", -1)
const _hoisted_171 = /*#__PURE__*/_createElementVNode("option", { value: "MK" }, " Macedonia, the former Yugoslav Republic of ", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("option", { value: "MG" }, "Madagascar", -1)
const _hoisted_173 = /*#__PURE__*/_createElementVNode("option", { value: "MW" }, "Malawi", -1)
const _hoisted_174 = /*#__PURE__*/_createElementVNode("option", { value: "MY" }, "Malaysia", -1)
const _hoisted_175 = /*#__PURE__*/_createElementVNode("option", { value: "MV" }, "Maldives", -1)
const _hoisted_176 = /*#__PURE__*/_createElementVNode("option", { value: "ML" }, "Mali", -1)
const _hoisted_177 = /*#__PURE__*/_createElementVNode("option", { value: "MT" }, "Malta", -1)
const _hoisted_178 = /*#__PURE__*/_createElementVNode("option", { value: "MH" }, "Marshall Islands", -1)
const _hoisted_179 = /*#__PURE__*/_createElementVNode("option", { value: "MQ" }, "Martinique", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("option", { value: "MR" }, "Mauritania", -1)
const _hoisted_181 = /*#__PURE__*/_createElementVNode("option", { value: "MU" }, "Mauritius", -1)
const _hoisted_182 = /*#__PURE__*/_createElementVNode("option", { value: "YT" }, "Mayotte", -1)
const _hoisted_183 = /*#__PURE__*/_createElementVNode("option", { value: "MX" }, "Mexico", -1)
const _hoisted_184 = /*#__PURE__*/_createElementVNode("option", { value: "FM" }, "Micronesia, Federated States of", -1)
const _hoisted_185 = /*#__PURE__*/_createElementVNode("option", { value: "MD" }, "Moldova, Republic of", -1)
const _hoisted_186 = /*#__PURE__*/_createElementVNode("option", { value: "MC" }, "Monaco", -1)
const _hoisted_187 = /*#__PURE__*/_createElementVNode("option", { value: "MN" }, "Mongolia", -1)
const _hoisted_188 = /*#__PURE__*/_createElementVNode("option", { value: "ME" }, "Montenegro", -1)
const _hoisted_189 = /*#__PURE__*/_createElementVNode("option", { value: "MS" }, "Montserrat", -1)
const _hoisted_190 = /*#__PURE__*/_createElementVNode("option", { value: "MA" }, "Morocco", -1)
const _hoisted_191 = /*#__PURE__*/_createElementVNode("option", { value: "MZ" }, "Mozambique", -1)
const _hoisted_192 = /*#__PURE__*/_createElementVNode("option", { value: "MM" }, "Myanmar", -1)
const _hoisted_193 = /*#__PURE__*/_createElementVNode("option", { value: "NA" }, "Namibia", -1)
const _hoisted_194 = /*#__PURE__*/_createElementVNode("option", { value: "NR" }, "Nauru", -1)
const _hoisted_195 = /*#__PURE__*/_createElementVNode("option", { value: "NP" }, "Nepal", -1)
const _hoisted_196 = /*#__PURE__*/_createElementVNode("option", { value: "NL" }, "Netherlands", -1)
const _hoisted_197 = /*#__PURE__*/_createElementVNode("option", { value: "NC" }, "New Caledonia", -1)
const _hoisted_198 = /*#__PURE__*/_createElementVNode("option", { value: "NZ" }, "New Zealand", -1)
const _hoisted_199 = /*#__PURE__*/_createElementVNode("option", { value: "NI" }, "Nicaragua", -1)
const _hoisted_200 = /*#__PURE__*/_createElementVNode("option", { value: "NE" }, "Niger", -1)
const _hoisted_201 = /*#__PURE__*/_createElementVNode("option", { value: "NG" }, "Nigeria", -1)
const _hoisted_202 = /*#__PURE__*/_createElementVNode("option", { value: "NU" }, "Niue", -1)
const _hoisted_203 = /*#__PURE__*/_createElementVNode("option", { value: "NF" }, "Norfolk Island", -1)
const _hoisted_204 = /*#__PURE__*/_createElementVNode("option", { value: "MP" }, "Northern Mariana Islands", -1)
const _hoisted_205 = /*#__PURE__*/_createElementVNode("option", { value: "NO" }, "Norway", -1)
const _hoisted_206 = /*#__PURE__*/_createElementVNode("option", { value: "OM" }, "Oman", -1)
const _hoisted_207 = /*#__PURE__*/_createElementVNode("option", { value: "PK" }, "Pakistan", -1)
const _hoisted_208 = /*#__PURE__*/_createElementVNode("option", { value: "PW" }, "Palau", -1)
const _hoisted_209 = /*#__PURE__*/_createElementVNode("option", { value: "PS" }, "Palestinian Territory, Occupied", -1)
const _hoisted_210 = /*#__PURE__*/_createElementVNode("option", { value: "PA" }, "Panama", -1)
const _hoisted_211 = /*#__PURE__*/_createElementVNode("option", { value: "PG" }, "Papua New Guinea", -1)
const _hoisted_212 = /*#__PURE__*/_createElementVNode("option", { value: "PY" }, "Paraguay", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("option", { value: "PE" }, "Peru", -1)
const _hoisted_214 = /*#__PURE__*/_createElementVNode("option", { value: "PH" }, "Philippines", -1)
const _hoisted_215 = /*#__PURE__*/_createElementVNode("option", { value: "PN" }, "Pitcairn", -1)
const _hoisted_216 = /*#__PURE__*/_createElementVNode("option", { value: "PL" }, "Poland", -1)
const _hoisted_217 = /*#__PURE__*/_createElementVNode("option", { value: "PT" }, "Portugal", -1)
const _hoisted_218 = /*#__PURE__*/_createElementVNode("option", { value: "PR" }, "Puerto Rico", -1)
const _hoisted_219 = /*#__PURE__*/_createElementVNode("option", { value: "QA" }, "Qatar", -1)
const _hoisted_220 = /*#__PURE__*/_createElementVNode("option", { value: "RE" }, "Réunion", -1)
const _hoisted_221 = /*#__PURE__*/_createElementVNode("option", { value: "RO" }, "Romania", -1)
const _hoisted_222 = /*#__PURE__*/_createElementVNode("option", { value: "RU" }, "Russian Federation", -1)
const _hoisted_223 = /*#__PURE__*/_createElementVNode("option", { value: "RW" }, "Rwanda", -1)
const _hoisted_224 = /*#__PURE__*/_createElementVNode("option", { value: "BL" }, "Saint Barthélemy", -1)
const _hoisted_225 = /*#__PURE__*/_createElementVNode("option", { value: "SH" }, " Saint Helena, Ascension and Tristan da Cunha ", -1)
const _hoisted_226 = /*#__PURE__*/_createElementVNode("option", { value: "KN" }, "Saint Kitts and Nevis", -1)
const _hoisted_227 = /*#__PURE__*/_createElementVNode("option", { value: "LC" }, "Saint Lucia", -1)
const _hoisted_228 = /*#__PURE__*/_createElementVNode("option", { value: "MF" }, "Saint Martin (French part)", -1)
const _hoisted_229 = /*#__PURE__*/_createElementVNode("option", { value: "PM" }, "Saint Pierre and Miquelon", -1)
const _hoisted_230 = /*#__PURE__*/_createElementVNode("option", { value: "VC" }, "Saint Vincent and the Grenadines", -1)
const _hoisted_231 = /*#__PURE__*/_createElementVNode("option", { value: "WS" }, "Samoa", -1)
const _hoisted_232 = /*#__PURE__*/_createElementVNode("option", { value: "SM" }, "San Marino", -1)
const _hoisted_233 = /*#__PURE__*/_createElementVNode("option", { value: "ST" }, "Sao Tome and Principe", -1)
const _hoisted_234 = /*#__PURE__*/_createElementVNode("option", { value: "SA" }, "Saudi Arabia", -1)
const _hoisted_235 = /*#__PURE__*/_createElementVNode("option", { value: "SN" }, "Senegal", -1)
const _hoisted_236 = /*#__PURE__*/_createElementVNode("option", { value: "RS" }, "Serbia", -1)
const _hoisted_237 = /*#__PURE__*/_createElementVNode("option", { value: "SC" }, "Seychelles", -1)
const _hoisted_238 = /*#__PURE__*/_createElementVNode("option", { value: "SL" }, "Sierra Leone", -1)
const _hoisted_239 = /*#__PURE__*/_createElementVNode("option", { value: "SG" }, "Singapore", -1)
const _hoisted_240 = /*#__PURE__*/_createElementVNode("option", { value: "SX" }, "Sint Maarten (Dutch part)", -1)
const _hoisted_241 = /*#__PURE__*/_createElementVNode("option", { value: "SK" }, "Slovakia", -1)
const _hoisted_242 = /*#__PURE__*/_createElementVNode("option", { value: "SI" }, "Slovenia", -1)
const _hoisted_243 = /*#__PURE__*/_createElementVNode("option", { value: "SB" }, "Solomon Islands", -1)
const _hoisted_244 = /*#__PURE__*/_createElementVNode("option", { value: "SO" }, "Somalia", -1)
const _hoisted_245 = /*#__PURE__*/_createElementVNode("option", { value: "ZA" }, "South Africa", -1)
const _hoisted_246 = /*#__PURE__*/_createElementVNode("option", { value: "GS" }, " South Georgia and the South Sandwich Islands ", -1)
const _hoisted_247 = /*#__PURE__*/_createElementVNode("option", { value: "KR" }, "South Korea", -1)
const _hoisted_248 = /*#__PURE__*/_createElementVNode("option", { value: "SS" }, "South Sudan", -1)
const _hoisted_249 = /*#__PURE__*/_createElementVNode("option", { value: "ES" }, "Spain", -1)
const _hoisted_250 = /*#__PURE__*/_createElementVNode("option", { value: "LK" }, "Sri Lanka", -1)
const _hoisted_251 = /*#__PURE__*/_createElementVNode("option", { value: "SD" }, "Sudan", -1)
const _hoisted_252 = /*#__PURE__*/_createElementVNode("option", { value: "SR" }, "Suriname", -1)
const _hoisted_253 = /*#__PURE__*/_createElementVNode("option", { value: "SJ" }, "Svalbard and Jan Mayen", -1)
const _hoisted_254 = /*#__PURE__*/_createElementVNode("option", { value: "SZ" }, "Swaziland", -1)
const _hoisted_255 = /*#__PURE__*/_createElementVNode("option", { value: "SE" }, "Sweden", -1)
const _hoisted_256 = /*#__PURE__*/_createElementVNode("option", { value: "CH" }, "Switzerland", -1)
const _hoisted_257 = /*#__PURE__*/_createElementVNode("option", { value: "SY" }, "Syrian Arab Republic", -1)
const _hoisted_258 = /*#__PURE__*/_createElementVNode("option", { value: "TW" }, "Taiwan, Province of China", -1)
const _hoisted_259 = /*#__PURE__*/_createElementVNode("option", { value: "TJ" }, "Tajikistan", -1)
const _hoisted_260 = /*#__PURE__*/_createElementVNode("option", { value: "TZ" }, "Tanzania, United Republic of", -1)
const _hoisted_261 = /*#__PURE__*/_createElementVNode("option", { value: "TH" }, "Thailand", -1)
const _hoisted_262 = /*#__PURE__*/_createElementVNode("option", { value: "TL" }, "Timor-Leste", -1)
const _hoisted_263 = /*#__PURE__*/_createElementVNode("option", { value: "TG" }, "Togo", -1)
const _hoisted_264 = /*#__PURE__*/_createElementVNode("option", { value: "TK" }, "Tokelau", -1)
const _hoisted_265 = /*#__PURE__*/_createElementVNode("option", { value: "TO" }, "Tonga", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("option", { value: "TT" }, "Trinidad and Tobago", -1)
const _hoisted_267 = /*#__PURE__*/_createElementVNode("option", { value: "TN" }, "Tunisia", -1)
const _hoisted_268 = /*#__PURE__*/_createElementVNode("option", { value: "TR" }, "Turkey", -1)
const _hoisted_269 = /*#__PURE__*/_createElementVNode("option", { value: "TM" }, "Turkmenistan", -1)
const _hoisted_270 = /*#__PURE__*/_createElementVNode("option", { value: "TC" }, "Turks and Caicos Islands", -1)
const _hoisted_271 = /*#__PURE__*/_createElementVNode("option", { value: "TV" }, "Tuvalu", -1)
const _hoisted_272 = /*#__PURE__*/_createElementVNode("option", { value: "UG" }, "Uganda", -1)
const _hoisted_273 = /*#__PURE__*/_createElementVNode("option", { value: "UA" }, "Ukraine", -1)
const _hoisted_274 = /*#__PURE__*/_createElementVNode("option", { value: "AE" }, "United Arab Emirates", -1)
const _hoisted_275 = /*#__PURE__*/_createElementVNode("option", { value: "GB" }, "United Kingdom", -1)
const _hoisted_276 = /*#__PURE__*/_createElementVNode("option", { value: "US" }, "United States", -1)
const _hoisted_277 = /*#__PURE__*/_createElementVNode("option", { value: "UY" }, "Uruguay", -1)
const _hoisted_278 = /*#__PURE__*/_createElementVNode("option", { value: "UZ" }, "Uzbekistan", -1)
const _hoisted_279 = /*#__PURE__*/_createElementVNode("option", { value: "VU" }, "Vanuatu", -1)
const _hoisted_280 = /*#__PURE__*/_createElementVNode("option", { value: "VE" }, "Venezuela, Bolivarian Republic of", -1)
const _hoisted_281 = /*#__PURE__*/_createElementVNode("option", { value: "VN" }, "Vietnam", -1)
const _hoisted_282 = /*#__PURE__*/_createElementVNode("option", { value: "VI" }, "Virgin Islands", -1)
const _hoisted_283 = /*#__PURE__*/_createElementVNode("option", { value: "WF" }, "Wallis and Futuna", -1)
const _hoisted_284 = /*#__PURE__*/_createElementVNode("option", { value: "EH" }, "Western Sahara", -1)
const _hoisted_285 = /*#__PURE__*/_createElementVNode("option", { value: "YE" }, "Yemen", -1)
const _hoisted_286 = /*#__PURE__*/_createElementVNode("option", { value: "ZM" }, "Zambia", -1)
const _hoisted_287 = /*#__PURE__*/_createElementVNode("option", { value: "ZW" }, "Zimbabwe", -1)
const _hoisted_288 = { class: "fv-plugins-message-container" }
const _hoisted_289 = { class: "fv-help-block" }
const _hoisted_290 = { class: "row mb-6" }
const _hoisted_291 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Language", -1)
const _hoisted_292 = { class: "col-lg-8 fv-row" }
const _hoisted_293 = /*#__PURE__*/_createElementVNode("option", { value: "id" }, "Bahasa Indonesia - Indonesian", -1)
const _hoisted_294 = /*#__PURE__*/_createElementVNode("option", { value: "msa" }, "Bahasa Melayu - Malay", -1)
const _hoisted_295 = /*#__PURE__*/_createElementVNode("option", { value: "ca" }, "Català - Catalan", -1)
const _hoisted_296 = /*#__PURE__*/_createElementVNode("option", { value: "cs" }, "Čeština - Czech", -1)
const _hoisted_297 = /*#__PURE__*/_createElementVNode("option", { value: "da" }, "Dansk - Danish", -1)
const _hoisted_298 = /*#__PURE__*/_createElementVNode("option", { value: "de" }, "Deutsch - German", -1)
const _hoisted_299 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1)
const _hoisted_300 = /*#__PURE__*/_createElementVNode("option", { value: "en-gb" }, "English UK - British English", -1)
const _hoisted_301 = /*#__PURE__*/_createElementVNode("option", { value: "es" }, "Español - Spanish", -1)
const _hoisted_302 = /*#__PURE__*/_createElementVNode("option", { value: "fil" }, "Filipino", -1)
const _hoisted_303 = /*#__PURE__*/_createElementVNode("option", { value: "fr" }, "Français - French", -1)
const _hoisted_304 = /*#__PURE__*/_createElementVNode("option", { value: "ga" }, "Gaeilge - Irish (beta)", -1)
const _hoisted_305 = /*#__PURE__*/_createElementVNode("option", { value: "gl" }, "Galego - Galician (beta)", -1)
const _hoisted_306 = /*#__PURE__*/_createElementVNode("option", { value: "hr" }, "Hrvatski - Croatian", -1)
const _hoisted_307 = /*#__PURE__*/_createElementVNode("option", { value: "it" }, "Italiano - Italian", -1)
const _hoisted_308 = /*#__PURE__*/_createElementVNode("option", { value: "hu" }, "Magyar - Hungarian", -1)
const _hoisted_309 = /*#__PURE__*/_createElementVNode("option", { value: "nl" }, "Nederlands - Dutch", -1)
const _hoisted_310 = /*#__PURE__*/_createElementVNode("option", { value: "no" }, "Norsk - Norwegian", -1)
const _hoisted_311 = /*#__PURE__*/_createElementVNode("option", { value: "pl" }, "Polski - Polish", -1)
const _hoisted_312 = /*#__PURE__*/_createElementVNode("option", { value: "pt" }, "Português - Portuguese", -1)
const _hoisted_313 = /*#__PURE__*/_createElementVNode("option", { value: "ro" }, "Română - Romanian", -1)
const _hoisted_314 = /*#__PURE__*/_createElementVNode("option", { value: "sk" }, "Slovenčina - Slovak", -1)
const _hoisted_315 = /*#__PURE__*/_createElementVNode("option", { value: "fi" }, "Suomi - Finnish", -1)
const _hoisted_316 = /*#__PURE__*/_createElementVNode("option", { value: "sv" }, "Svenska - Swedish", -1)
const _hoisted_317 = /*#__PURE__*/_createElementVNode("option", { value: "vi" }, "Tiếng Việt - Vietnamese", -1)
const _hoisted_318 = /*#__PURE__*/_createElementVNode("option", { value: "tr" }, "Türkçe - Turkish", -1)
const _hoisted_319 = /*#__PURE__*/_createElementVNode("option", { value: "el" }, "Ελληνικά - Greek", -1)
const _hoisted_320 = /*#__PURE__*/_createElementVNode("option", { value: "bg" }, "Български език - Bulgarian", -1)
const _hoisted_321 = /*#__PURE__*/_createElementVNode("option", { value: "ru" }, "Русский - Russian", -1)
const _hoisted_322 = /*#__PURE__*/_createElementVNode("option", { value: "sr" }, "Српски - Serbian", -1)
const _hoisted_323 = /*#__PURE__*/_createElementVNode("option", { value: "uk" }, "Українська мова - Ukrainian", -1)
const _hoisted_324 = /*#__PURE__*/_createElementVNode("option", { value: "he" }, "עִבְרִית - Hebrew", -1)
const _hoisted_325 = /*#__PURE__*/_createElementVNode("option", { value: "ur" }, "اردو - Urdu (beta)", -1)
const _hoisted_326 = /*#__PURE__*/_createElementVNode("option", { value: "ar" }, "العربية - Arabic", -1)
const _hoisted_327 = /*#__PURE__*/_createElementVNode("option", { value: "fa" }, "فارسی - Persian", -1)
const _hoisted_328 = /*#__PURE__*/_createElementVNode("option", { value: "mr" }, "मराठी - Marathi", -1)
const _hoisted_329 = /*#__PURE__*/_createElementVNode("option", { value: "hi" }, "हिन्दी - Hindi", -1)
const _hoisted_330 = /*#__PURE__*/_createElementVNode("option", { value: "bn" }, "বাংলা - Bangla", -1)
const _hoisted_331 = /*#__PURE__*/_createElementVNode("option", { value: "gu" }, "ગુજરાતી - Gujarati", -1)
const _hoisted_332 = /*#__PURE__*/_createElementVNode("option", { value: "ta" }, "தமிழ் - Tamil", -1)
const _hoisted_333 = /*#__PURE__*/_createElementVNode("option", { value: "kn" }, "ಕನ್ನಡ - Kannada", -1)
const _hoisted_334 = /*#__PURE__*/_createElementVNode("option", { value: "th" }, "ภาษาไทย - Thai", -1)
const _hoisted_335 = /*#__PURE__*/_createElementVNode("option", { value: "ko" }, "한국어 - Korean", -1)
const _hoisted_336 = /*#__PURE__*/_createElementVNode("option", { value: "ja" }, "日本語 - Japanese", -1)
const _hoisted_337 = /*#__PURE__*/_createElementVNode("option", { value: "zh-cn" }, "简体中文 - Simplified Chinese", -1)
const _hoisted_338 = /*#__PURE__*/_createElementVNode("option", { value: "zh-tw" }, "繁體中文 - Traditional Chinese", -1)
const _hoisted_339 = { class: "fv-plugins-message-container" }
const _hoisted_340 = { class: "fv-help-block" }
const _hoisted_341 = /*#__PURE__*/_createElementVNode("div", { class: "form-text" }, " Please select a preferred language, including date, time, and number formatting. ", -1)
const _hoisted_342 = { class: "row mb-6" }
const _hoisted_343 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Time Zone", -1)
const _hoisted_344 = { class: "col-lg-8 fv-row" }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-39600",
  value: "International Date Line West"
}, " (GMT-11:00) International Date Line West ", -1)
const _hoisted_346 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-39600",
  value: "Midway Island"
}, " (GMT-11:00) Midway Island ", -1)
const _hoisted_347 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-39600",
  value: "Samoa"
}, " (GMT-11:00) Samoa ", -1)
const _hoisted_348 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-36000",
  value: "Hawaii"
}, " (GMT-10:00) Hawaii ", -1)
const _hoisted_349 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-28800",
  value: "Alaska"
}, " (GMT-08:00) Alaska ", -1)
const _hoisted_350 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-25200",
  value: "Pacific Time (US & Canada)"
}, " (GMT-07:00) Pacific Time (US & Canada) ", -1)
const _hoisted_351 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-25200",
  value: "Tijuana"
}, " (GMT-07:00) Tijuana ", -1)
const _hoisted_352 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-25200",
  value: "Arizona"
}, " (GMT-07:00) Arizona ", -1)
const _hoisted_353 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-21600",
  value: "Mountain Time (US & Canada)"
}, " (GMT-06:00) Mountain Time (US & Canada) ", -1)
const _hoisted_354 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-21600",
  value: "Chihuahua"
}, " (GMT-06:00) Chihuahua ", -1)
const _hoisted_355 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-21600",
  value: "Mazatlan"
}, " (GMT-06:00) Mazatlan ", -1)
const _hoisted_356 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-21600",
  value: "Saskatchewan"
}, " (GMT-06:00) Saskatchewan ", -1)
const _hoisted_357 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-21600",
  value: "Central America"
}, " (GMT-06:00) Central America ", -1)
const _hoisted_358 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Central Time (US & Canada)"
}, " (GMT-05:00) Central Time (US & Canada) ", -1)
const _hoisted_359 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Guadalajara"
}, " (GMT-05:00) Guadalajara ", -1)
const _hoisted_360 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Mexico City"
}, " (GMT-05:00) Mexico City ", -1)
const _hoisted_361 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Monterrey"
}, " (GMT-05:00) Monterrey ", -1)
const _hoisted_362 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Bogota"
}, " (GMT-05:00) Bogota ", -1)
const _hoisted_363 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Lima"
}, " (GMT-05:00) Lima ", -1)
const _hoisted_364 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-18000",
  value: "Quito"
}, " (GMT-05:00) Quito ", -1)
const _hoisted_365 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-14400",
  value: "Eastern Time (US & Canada)"
}, " (GMT-04:00) Eastern Time (US & Canada) ", -1)
const _hoisted_366 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-14400",
  value: "Indiana (East)"
}, " (GMT-04:00) Indiana (East) ", -1)
const _hoisted_367 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-14400",
  value: "Caracas"
}, " (GMT-04:00) Caracas ", -1)
const _hoisted_368 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-14400",
  value: "La Paz"
}, " (GMT-04:00) La Paz ", -1)
const _hoisted_369 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-14400",
  value: "Georgetown"
}, " (GMT-04:00) Georgetown ", -1)
const _hoisted_370 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-10800",
  value: "Atlantic Time (Canada)"
}, " (GMT-03:00) Atlantic Time (Canada) ", -1)
const _hoisted_371 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-10800",
  value: "Santiago"
}, " (GMT-03:00) Santiago ", -1)
const _hoisted_372 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-10800",
  value: "Brasilia"
}, " (GMT-03:00) Brasilia ", -1)
const _hoisted_373 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-10800",
  value: "Buenos Aires"
}, " (GMT-03:00) Buenos Aires ", -1)
const _hoisted_374 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-9000",
  value: "Newfoundland"
}, " (GMT-02:30) Newfoundland ", -1)
const _hoisted_375 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-7200",
  value: "Greenland"
}, " (GMT-02:00) Greenland ", -1)
const _hoisted_376 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-7200",
  value: "Mid-Atlantic"
}, " (GMT-02:00) Mid-Atlantic ", -1)
const _hoisted_377 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "-3600",
  value: "Cape Verde Is."
}, " (GMT-01:00) Cape Verde Is. ", -1)
const _hoisted_378 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "0",
  value: "Azores"
}, "(GMT) Azores", -1)
const _hoisted_379 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "0",
  value: "Monrovia"
}, " (GMT) Monrovia ", -1)
const _hoisted_380 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "0",
  value: "UTC"
}, "(GMT) UTC", -1)
const _hoisted_381 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "Dublin"
}, " (GMT+01:00) Dublin ", -1)
const _hoisted_382 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "Edinburgh"
}, " (GMT+01:00) Edinburgh ", -1)
const _hoisted_383 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "Lisbon"
}, " (GMT+01:00) Lisbon ", -1)
const _hoisted_384 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "London"
}, " (GMT+01:00) London ", -1)
const _hoisted_385 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "Casablanca"
}, " (GMT+01:00) Casablanca ", -1)
const _hoisted_386 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "3600",
  value: "West Central Africa"
}, " (GMT+01:00) West Central Africa ", -1)
const _hoisted_387 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Belgrade"
}, " (GMT+02:00) Belgrade ", -1)
const _hoisted_388 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Bratislava"
}, " (GMT+02:00) Bratislava ", -1)
const _hoisted_389 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Budapest"
}, " (GMT+02:00) Budapest ", -1)
const _hoisted_390 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Ljubljana"
}, " (GMT+02:00) Ljubljana ", -1)
const _hoisted_391 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Prague"
}, " (GMT+02:00) Prague ", -1)
const _hoisted_392 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Sarajevo"
}, " (GMT+02:00) Sarajevo ", -1)
const _hoisted_393 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Skopje"
}, " (GMT+02:00) Skopje ", -1)
const _hoisted_394 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Warsaw"
}, " (GMT+02:00) Warsaw ", -1)
const _hoisted_395 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Zagreb"
}, " (GMT+02:00) Zagreb ", -1)
const _hoisted_396 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Brussels"
}, " (GMT+02:00) Brussels ", -1)
const _hoisted_397 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Copenhagen"
}, " (GMT+02:00) Copenhagen ", -1)
const _hoisted_398 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Madrid"
}, " (GMT+02:00) Madrid ", -1)
const _hoisted_399 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Paris"
}, " (GMT+02:00) Paris ", -1)
const _hoisted_400 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Amsterdam"
}, " (GMT+02:00) Amsterdam ", -1)
const _hoisted_401 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Berlin"
}, " (GMT+02:00) Berlin ", -1)
const _hoisted_402 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Bern"
}, " (GMT+02:00) Bern ", -1)
const _hoisted_403 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Rome"
}, " (GMT+02:00) Rome ", -1)
const _hoisted_404 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Stockholm"
}, " (GMT+02:00) Stockholm ", -1)
const _hoisted_405 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Vienna"
}, " (GMT+02:00) Vienna ", -1)
const _hoisted_406 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Cairo"
}, " (GMT+02:00) Cairo ", -1)
const _hoisted_407 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Harare"
}, " (GMT+02:00) Harare ", -1)
const _hoisted_408 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "7200",
  value: "Pretoria"
}, " (GMT+02:00) Pretoria ", -1)
const _hoisted_409 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Bucharest"
}, " (GMT+03:00) Bucharest ", -1)
const _hoisted_410 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Helsinki"
}, " (GMT+03:00) Helsinki ", -1)
const _hoisted_411 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Kiev"
}, " (GMT+03:00) Kiev ", -1)
const _hoisted_412 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Kyiv"
}, " (GMT+03:00) Kyiv ", -1)
const _hoisted_413 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Riga"
}, " (GMT+03:00) Riga ", -1)
const _hoisted_414 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Sofia"
}, " (GMT+03:00) Sofia ", -1)
const _hoisted_415 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Tallinn"
}, " (GMT+03:00) Tallinn ", -1)
const _hoisted_416 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Vilnius"
}, " (GMT+03:00) Vilnius ", -1)
const _hoisted_417 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Athens"
}, " (GMT+03:00) Athens ", -1)
const _hoisted_418 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Istanbul"
}, " (GMT+03:00) Istanbul ", -1)
const _hoisted_419 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Minsk"
}, " (GMT+03:00) Minsk ", -1)
const _hoisted_420 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Jerusalem"
}, " (GMT+03:00) Jerusalem ", -1)
const _hoisted_421 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Moscow"
}, " (GMT+03:00) Moscow ", -1)
const _hoisted_422 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "St. Petersburg"
}, " (GMT+03:00) St. Petersburg ", -1)
const _hoisted_423 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Volgograd"
}, " (GMT+03:00) Volgograd ", -1)
const _hoisted_424 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Kuwait"
}, " (GMT+03:00) Kuwait ", -1)
const _hoisted_425 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Riyadh"
}, " (GMT+03:00) Riyadh ", -1)
const _hoisted_426 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Nairobi"
}, " (GMT+03:00) Nairobi ", -1)
const _hoisted_427 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "10800",
  value: "Baghdad"
}, " (GMT+03:00) Baghdad ", -1)
const _hoisted_428 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "14400",
  value: "Abu Dhabi"
}, " (GMT+04:00) Abu Dhabi ", -1)
const _hoisted_429 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "14400",
  value: "Muscat"
}, " (GMT+04:00) Muscat ", -1)
const _hoisted_430 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "14400",
  value: "Baku"
}, " (GMT+04:00) Baku ", -1)
const _hoisted_431 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "14400",
  value: "Tbilisi"
}, " (GMT+04:00) Tbilisi ", -1)
const _hoisted_432 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "14400",
  value: "Yerevan"
}, " (GMT+04:00) Yerevan ", -1)
const _hoisted_433 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "16200",
  value: "Tehran"
}, " (GMT+04:30) Tehran ", -1)
const _hoisted_434 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "16200",
  value: "Kabul"
}, " (GMT+04:30) Kabul ", -1)
const _hoisted_435 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "18000",
  value: "Ekaterinburg"
}, " (GMT+05:00) Ekaterinburg ", -1)
const _hoisted_436 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "18000",
  value: "Islamabad"
}, " (GMT+05:00) Islamabad ", -1)
const _hoisted_437 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "18000",
  value: "Karachi"
}, " (GMT+05:00) Karachi ", -1)
const _hoisted_438 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "18000",
  value: "Tashkent"
}, " (GMT+05:00) Tashkent ", -1)
const _hoisted_439 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "19800",
  value: "Chennai"
}, " (GMT+05:30) Chennai ", -1)
const _hoisted_440 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "19800",
  value: "Kolkata"
}, " (GMT+05:30) Kolkata ", -1)
const _hoisted_441 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "19800",
  value: "Mumbai"
}, " (GMT+05:30) Mumbai ", -1)
const _hoisted_442 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "19800",
  value: "New Delhi"
}, " (GMT+05:30) New Delhi ", -1)
const _hoisted_443 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "19800",
  value: "Sri Jayawardenepura"
}, " (GMT+05:30) Sri Jayawardenepura ", -1)
const _hoisted_444 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "20700",
  value: "Kathmandu"
}, " (GMT+05:45) Kathmandu ", -1)
const _hoisted_445 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "21600",
  value: "Astana"
}, " (GMT+06:00) Astana ", -1)
const _hoisted_446 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "21600",
  value: "Dhaka"
}, " (GMT+06:00) Dhaka ", -1)
const _hoisted_447 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "21600",
  value: "Almaty"
}, " (GMT+06:00) Almaty ", -1)
const _hoisted_448 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "21600",
  value: "Urumqi"
}, " (GMT+06:00) Urumqi ", -1)
const _hoisted_449 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "23400",
  value: "Rangoon"
}, " (GMT+06:30) Rangoon ", -1)
const _hoisted_450 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "25200",
  value: "Novosibirsk"
}, " (GMT+07:00) Novosibirsk ", -1)
const _hoisted_451 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "25200",
  value: "Bangkok"
}, " (GMT+07:00) Bangkok ", -1)
const _hoisted_452 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "25200",
  value: "Hanoi"
}, " (GMT+07:00) Hanoi ", -1)
const _hoisted_453 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "25200",
  value: "Jakarta"
}, " (GMT+07:00) Jakarta ", -1)
const _hoisted_454 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "25200",
  value: "Krasnoyarsk"
}, " (GMT+07:00) Krasnoyarsk ", -1)
const _hoisted_455 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Beijing"
}, " (GMT+08:00) Beijing ", -1)
const _hoisted_456 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Chongqing"
}, " (GMT+08:00) Chongqing ", -1)
const _hoisted_457 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Hong Kong"
}, " (GMT+08:00) Hong Kong ", -1)
const _hoisted_458 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Kuala Lumpur"
}, " (GMT+08:00) Kuala Lumpur ", -1)
const _hoisted_459 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Singapore"
}, " (GMT+08:00) Singapore ", -1)
const _hoisted_460 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Taipei"
}, " (GMT+08:00) Taipei ", -1)
const _hoisted_461 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Perth"
}, " (GMT+08:00) Perth ", -1)
const _hoisted_462 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Irkutsk"
}, " (GMT+08:00) Irkutsk ", -1)
const _hoisted_463 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "28800",
  value: "Ulaan Bataar"
}, " (GMT+08:00) Ulaan Bataar ", -1)
const _hoisted_464 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "32400",
  value: "Seoul"
}, " (GMT+09:00) Seoul ", -1)
const _hoisted_465 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "32400",
  value: "Osaka"
}, " (GMT+09:00) Osaka ", -1)
const _hoisted_466 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "32400",
  value: "Sapporo"
}, " (GMT+09:00) Sapporo ", -1)
const _hoisted_467 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "32400",
  value: "Tokyo"
}, " (GMT+09:00) Tokyo ", -1)
const _hoisted_468 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "32400",
  value: "Yakutsk"
}, " (GMT+09:00) Yakutsk ", -1)
const _hoisted_469 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "34200",
  value: "Darwin"
}, " (GMT+09:30) Darwin ", -1)
const _hoisted_470 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "34200",
  value: "Adelaide"
}, " (GMT+09:30) Adelaide ", -1)
const _hoisted_471 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Canberra"
}, " (GMT+10:00) Canberra ", -1)
const _hoisted_472 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Melbourne"
}, " (GMT+10:00) Melbourne ", -1)
const _hoisted_473 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Sydney"
}, " (GMT+10:00) Sydney ", -1)
const _hoisted_474 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Brisbane"
}, " (GMT+10:00) Brisbane ", -1)
const _hoisted_475 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Hobart"
}, " (GMT+10:00) Hobart ", -1)
const _hoisted_476 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Vladivostok"
}, " (GMT+10:00) Vladivostok ", -1)
const _hoisted_477 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Guam"
}, " (GMT+10:00) Guam ", -1)
const _hoisted_478 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Port Moresby"
}, " (GMT+10:00) Port Moresby ", -1)
const _hoisted_479 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "36000",
  value: "Solomon Is."
}, " (GMT+10:00) Solomon Is. ", -1)
const _hoisted_480 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "39600",
  value: "Magadan"
}, " (GMT+11:00) Magadan ", -1)
const _hoisted_481 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "39600",
  value: "New Caledonia"
}, " (GMT+11:00) New Caledonia ", -1)
const _hoisted_482 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "43200",
  value: "Fiji"
}, " (GMT+12:00) Fiji ", -1)
const _hoisted_483 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "43200",
  value: "Kamchatka"
}, " (GMT+12:00) Kamchatka ", -1)
const _hoisted_484 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "43200",
  value: "Marshall Is."
}, " (GMT+12:00) Marshall Is. ", -1)
const _hoisted_485 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "43200",
  value: "Auckland"
}, " (GMT+12:00) Auckland ", -1)
const _hoisted_486 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "43200",
  value: "Wellington"
}, " (GMT+12:00) Wellington ", -1)
const _hoisted_487 = /*#__PURE__*/_createElementVNode("option", {
  "data-bs-offset": "46800",
  value: "Nuku'alofa"
}, " (GMT+13:00) Nuku'alofa ", -1)
const _hoisted_488 = { class: "fv-plugins-message-container" }
const _hoisted_489 = { class: "fv-help-block" }
const _hoisted_490 = { class: "row mb-6" }
const _hoisted_491 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Currency", -1)
const _hoisted_492 = { class: "col-lg-8 fv-row" }
const _hoisted_493 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/united-states.svg",
  value: "USD"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "USD"),
  /*#__PURE__*/_createTextVNode(" - USA dollar ")
], -1)
const _hoisted_494 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/united-kingdom.svg",
  value: "GBP"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "GBP"),
  /*#__PURE__*/_createTextVNode(" - British pound ")
], -1)
const _hoisted_495 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/australia.svg",
  value: "AUD"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "AUD"),
  /*#__PURE__*/_createTextVNode(" - Australian dollar ")
], -1)
const _hoisted_496 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/japan.svg",
  value: "JPY"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "JPY"),
  /*#__PURE__*/_createTextVNode(" - Japanese yen ")
], -1)
const _hoisted_497 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/sweden.svg",
  value: "SEK"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "SEK"),
  /*#__PURE__*/_createTextVNode(" - Swedish krona ")
], -1)
const _hoisted_498 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/canada.svg",
  value: "CAD"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "CAD"),
  /*#__PURE__*/_createTextVNode(" - Canadian dollar ")
], -1)
const _hoisted_499 = /*#__PURE__*/_createElementVNode("option", {
  "data-kt-flag": "flags/switzerland.svg",
  value: "CHF"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "CHF"),
  /*#__PURE__*/_createTextVNode(" - Swiss franc ")
], -1)
const _hoisted_500 = { class: "fv-plugins-message-container" }
const _hoisted_501 = { class: "fv-help-block" }
const _hoisted_502 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-6" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Communication"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 fv-row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center mt-3" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-inline form-check-solid me-5" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          name: "communication[]",
          type: "checkbox"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ps-2 fs-6" }, " Email ")
      ]),
      /*#__PURE__*/_createElementVNode("label", { class: "form-check form-check-inline form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          name: "communication[]",
          type: "checkbox"
        }),
        /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ps-2 fs-6" }, " Phone ")
      ])
    ])
  ])
], -1)
const _hoisted_503 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-0" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Allow Marketing"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-lg-8 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-solid form-switch fv-row" }, [
      /*#__PURE__*/_createElementVNode("input", {
        class: "form-check-input w-45px h-30px",
        type: "checkbox",
        id: "allowmarketing"
      }),
      /*#__PURE__*/_createElementVNode("label", {
        class: "form-check-label",
        for: "allowmarketing"
      })
    ])
  ])
], -1)
const _hoisted_504 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_505 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  class: "btn btn-white btn-active-light-primary me-2"
}, " Discard ", -1)
const _hoisted_506 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton1",
  class: "btn btn-primary"
}
const _hoisted_507 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1)
const _hoisted_508 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_509 = [
  _hoisted_507,
  _hoisted_508
]
const _hoisted_510 = { class: "card mb-5 mb-xl-10" }
const _hoisted_511 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_signin_method"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Sign-in Method")
  ])
], -1)
const _hoisted_512 = {
  id: "kt_account_signin_method",
  class: "collapse show"
}
const _hoisted_513 = { class: "card-body border-top p-9" }
const _hoisted_514 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_515 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Email Address", -1)
const _hoisted_516 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "support@keenthemes.com", -1)
const _hoisted_517 = [
  _hoisted_515,
  _hoisted_516
]
const _hoisted_518 = { class: "row mb-6" }
const _hoisted_519 = { class: "col-lg-6 mb-4 mb-lg-0" }
const _hoisted_520 = { class: "fv-row mb-0" }
const _hoisted_521 = /*#__PURE__*/_createElementVNode("label", {
  for: "emailaddress",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Enter New Email Address", -1)
const _hoisted_522 = { class: "fv-plugins-message-container" }
const _hoisted_523 = { class: "fv-help-block" }
const _hoisted_524 = { class: "col-lg-6" }
const _hoisted_525 = { class: "fv-row mb-0" }
const _hoisted_526 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmemailpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm Password", -1)
const _hoisted_527 = { class: "fv-plugins-message-container" }
const _hoisted_528 = { class: "fv-help-block" }
const _hoisted_529 = { class: "d-flex" }
const _hoisted_530 = {
  id: "kt_signin_submit",
  type: "submit",
  ref: "updateEmailButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_531 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update Email ", -1)
const _hoisted_532 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_533 = [
  _hoisted_531,
  _hoisted_532
]
const _hoisted_534 = { class: "d-flex flex-wrap align-items-center mb-8" }
const _hoisted_535 = /*#__PURE__*/_createElementVNode("div", { class: "fs-4 fw-boldest mb-1" }, "Password", -1)
const _hoisted_536 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600" }, "************", -1)
const _hoisted_537 = [
  _hoisted_535,
  _hoisted_536
]
const _hoisted_538 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold text-gray-600 mb-4" }, " Password must be at least 8 character and contain symbols ", -1)
const _hoisted_539 = { class: "row mb-6" }
const _hoisted_540 = { class: "col-lg-4" }
const _hoisted_541 = { class: "fv-row mb-0" }
const _hoisted_542 = /*#__PURE__*/_createElementVNode("label", {
  for: "currentpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Current Password", -1)
const _hoisted_543 = { class: "fv-plugins-message-container" }
const _hoisted_544 = { class: "fv-help-block" }
const _hoisted_545 = { class: "col-lg-4" }
const _hoisted_546 = { class: "fv-row mb-0" }
const _hoisted_547 = /*#__PURE__*/_createElementVNode("label", {
  for: "newpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "New Password", -1)
const _hoisted_548 = { class: "fv-plugins-message-container" }
const _hoisted_549 = { class: "fv-help-block" }
const _hoisted_550 = { class: "col-lg-4" }
const _hoisted_551 = { class: "fv-row mb-0" }
const _hoisted_552 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmpassword",
  class: "form-label fs-6 fw-bolder mb-3"
}, "Confirm New Password", -1)
const _hoisted_553 = { class: "fv-plugins-message-container" }
const _hoisted_554 = { class: "fv-help-block" }
const _hoisted_555 = { class: "d-flex" }
const _hoisted_556 = {
  id: "kt_password_submit",
  type: "submit",
  ref: "updatePasswordButton",
  class: "btn btn-primary me-2 px-6"
}
const _hoisted_557 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Update Password ", -1)
const _hoisted_558 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_559 = [
  _hoisted_557,
  _hoisted_558
]
const _hoisted_560 = { class: "card mb-5 mb-xl-10" }
const _hoisted_561 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_connected_accounts",
  "aria-expanded": "true",
  "aria-controls": "kt_account_connected_accounts"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Connected Accounts")
  ])
], -1)
const _hoisted_562 = {
  id: "kt_account_connected_accounts",
  class: "collapse show"
}
const _hoisted_563 = { class: "card-body border-top p-9" }
const _hoisted_564 = { class: "\n            notice\n            d-flex\n            bg-light-primary\n            rounded\n            border-primary border border-dashed\n            mb-9\n            p-6\n          " }
const _hoisted_565 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_566 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-gray-600" }, [
      /*#__PURE__*/_createTextVNode(" Two-factor authentication adds an extra layer of security to your account. To log in, in you'll need to provide a 4 digit amazing code. "),
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "fw-bolder"
      }, "Learn More")
    ])
  ])
], -1)
const _hoisted_567 = /*#__PURE__*/_createStaticVNode("<div class=\"py-2\"><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/google-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Google</a><div class=\"fs-6 fw-bold text-gray-400\"> Plan properly your workflow </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"googleswitch\" checked><label class=\"form-check-label\" for=\"googleswitch\"></label></div></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/github.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Github</a><div class=\"fs-6 fw-bold text-gray-400\"> Keep eye on on your Repositories </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"githubswitch\" checked><label class=\"form-check-label\" for=\"githubswitch\"></label></div></div></div><div class=\"separator separator-dashed my-5\"></div><div class=\"d-flex flex-stack\"><div class=\"d-flex\"><img src=\"media/svg/brand-logos/slack-icon.svg\" class=\"w-30px me-6\" alt=\"\"><div class=\"d-flex flex-column\"><a href=\"#\" class=\"fs-5 text-dark text-hover-primary fw-bolder\">Slack</a><div class=\"fs-6 fw-bold text-gray-400\"> Integrate Projects Discussions </div></div></div><div class=\"d-flex justify-content-end\"><div class=\"form-check form-check-solid form-switch\"><input class=\"form-check-input w-45px h-30px\" type=\"checkbox\" id=\"slackswitch\"><label class=\"form-check-label\" for=\"slackswitch\"></label></div></div></div></div>", 1)
const _hoisted_568 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_569 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)
const _hoisted_570 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1)
const _hoisted_571 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_572 = [
  _hoisted_570,
  _hoisted_571
]
const _hoisted_573 = { class: "card mb-5 mb-xl-10" }
const _hoisted_574 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_email_preferences",
  "aria-expanded": "true",
  "aria-controls": "kt_account_email_preferences"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Email Preferences")
  ])
], -1)
const _hoisted_575 = {
  id: "kt_account_email_preferences",
  class: "collapse show"
}
const _hoisted_576 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body border-top px-9 py-9\"><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Successful Payments</span><span class=\"text-muted fs-6\">Receive a notification for every successful payment.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Payouts</span><span class=\"text-muted fs-6\">Receive a notification for every initiated payout.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Fee Collection</span><span class=\"text-muted fs-6\">Receive a notification each time you collect a fee from sales</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Customer Payment Dispute</span><span class=\"text-muted fs-6\">Receive a notification if a payment is disputed by a customer and for dispute purposes.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Refund Alerts</span><span class=\"text-muted fs-6\">Receive a notification if a payment is stated as risk by the Finance Department.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" checked value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Invoice Payments</span><span class=\"text-muted fs-6\">Receive a notification if a customer sends an incorrect amount to pay their invoice.</span></span></label><div class=\"separator separator-dashed my-6\"></div><label class=\"\n              form-check form-check-custom form-check-solid\n              align-items-start\n            \"><input class=\"form-check-input me-3\" type=\"checkbox\" name=\"email-preferences1\" value=\"1\"><span class=\"form-check-label d-flex flex-column align-items-start\"><span class=\"fw-bolder fs-5 mb-0\">Webhook API Endpoints</span><span class=\"text-muted fs-6\">Receive notifications for consistently failing webhook API endpoints.</span></span></label><div class=\"separator separator-dashed my-6\"></div></div>", 1)
const _hoisted_577 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_578 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)
const _hoisted_579 = {
  ref: "submitButton3",
  type: "submit",
  class: "btn btn-primary px-6"
}
const _hoisted_580 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1)
const _hoisted_581 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_582 = [
  _hoisted_580,
  _hoisted_581
]
const _hoisted_583 = { class: "card mb-5 mb-xl-10" }
const _hoisted_584 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_notifications",
  "aria-expanded": "true",
  "aria-controls": "kt_account_notifications"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Notifications")
  ])
], -1)
const _hoisted_585 = {
  id: "kt_account_notifications",
  class: "collapse show"
}
const _hoisted_586 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body border-top px-9 pt-3 pb-4\"><div class=\"table-responsive\"><table class=\"table table-row-dashed border-gray-300 align-middle gy-6\"><tbody class=\"fs-6 fw-bold\"><tr><td class=\"min-w-250px fs-4 fw-bolder\">Notifications</td><td class=\"w-125px\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"kt_settings_notification_email\" checked data-kt-check=\"true\" data-kt-check-target=\"[data-kt-settings-notification=email]\"><label class=\"form-check-label ps-2\" for=\"kt_settings_notification_email\"> Email </label></div></td><td class=\"w-125px\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"kt_settings_notification_phone\" checked data-kt-check=\"true\" data-kt-check-target=\"[data-kt-settings-notification=phone]\"><label class=\"form-check-label ps-2\" for=\"kt_settings_notification_phone\"> Phone </label></div></td></tr><tr><td>Billing Updates</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"1\" id=\"billing1\" checked data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"billing1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"billing2\" checked data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"billing2\"></label></div></td></tr><tr><td>New Team Members</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"team1\" checked data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"team1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"team2\" data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"team2\"></label></div></td></tr><tr><td>Completed Projects</td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"project1\" data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"project1\"></label></div></td><td><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"project2\" checked data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"project2\"></label></div></td></tr><tr><td class=\"border-bottom-0\">Newsletters</td><td class=\"border-bottom-0\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"newsletter1\" data-kt-settings-notification=\"email\"><label class=\"form-check-label ps-2\" for=\"newsletter1\"></label></div></td><td class=\"border-bottom-0\"><div class=\"form-check form-check-solid\"><input class=\"form-check-input\" type=\"checkbox\" value=\"\" id=\"newsletter2\" data-kt-settings-notification=\"phone\"><label class=\"form-check-label ps-2\" for=\"newsletter2\"></label></div></td></tr></tbody></table></div></div>", 1)
const _hoisted_587 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_588 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-white btn-active-light-primary me-2" }, " Discard ", -1)
const _hoisted_589 = {
  ref: "submitButton4",
  type: "submit",
  class: "btn btn-primary px-6"
}
const _hoisted_590 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Save Changes ", -1)
const _hoisted_591 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_592 = [
  _hoisted_590,
  _hoisted_591
]
const _hoisted_593 = { class: "card mb-5 mb-xl-10" }
const _hoisted_594 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_deactivate",
  "aria-expanded": "true",
  "aria-controls": "kt_account_deactivate"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-boldest m-0" }, "Deactivate Account")
  ])
], -1)
const _hoisted_595 = {
  id: "kt_account_deactivate",
  class: "collapse show"
}
const _hoisted_596 = { class: "card-body border-top p-9" }
const _hoisted_597 = { class: "\n              notice\n              d-flex\n              bg-light-warning\n              rounded\n              border-warning border border-dashed\n              mb-9\n              p-6\n            " }
const _hoisted_598 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_599 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-stack flex-grow-1\"><div class=\"fw-bold\"><h4 class=\"text-gray-800 fw-bolder\"> You Are Deactivating Your Account </h4><div class=\"fs-6 text-gray-600\"> For extra security, this requires you to confirm your email or phone number when you reset yousignr password. <br><a class=\"fw-bolder\" href=\"#\">Learn more</a></div></div></div>", 1)
const _hoisted_600 = /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-solid fv-row" }, [
  /*#__PURE__*/_createElementVNode("input", {
    name: "deactivate",
    class: "form-check-input",
    type: "checkbox",
    value: "",
    id: "deactivate"
  }),
  /*#__PURE__*/_createElementVNode("label", {
    class: "form-check-label fw-bold ps-2 fs-6",
    for: "deactivate"
  }, "Confirm Account Deactivation")
], -1)
const _hoisted_601 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_602 = {
  id: "kt_account_deactivate_account_submit",
  ref: "submitButton5",
  type: "submit",
  class: "btn btn-danger fw-bold"
}
const _hoisted_603 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Deactivate Account ", -1)
const _hoisted_604 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_605 = [
  _hoisted_603,
  _hoisted_604
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          id: "kt_account_profile_details_form",
          class: "form",
          novalidate: "novalidate",
          onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveChanges1())),
          "validation-schema": _ctx.profileDetailsValidator
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "image-input-wrapper w-125px h-125px",
                      style: _normalizeStyle(`background-image: url(${_ctx.profileDetails.avatar})`)
                    }, null, 4),
                    _hoisted_9,
                    _createElementVNode("span", {
                      class: "\n                    btn btn-icon btn-circle btn-active-color-primary\n                    w-25px\n                    h-25px\n                    bg-white\n                    shadow\n                  ",
                      "data-kt-image-input-action": "remove",
                      "data-bs-toggle": "tooltip",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.removeImage())),
                      title: "Remove avatar"
                    }, _hoisted_11)
                  ]),
                  _hoisted_12
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "fname",
                        class: "\n                      form-control form-control-lg form-control-solid\n                      mb-3 mb-lg-0\n                    ",
                        placeholder: "First name",
                        modelValue: _ctx.profileDetails.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.profileDetails.name = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_ErrorMessage, { name: "fname" })
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "lname",
                        class: "form-control form-control-lg form-control-solid",
                        placeholder: "Last name",
                        modelValue: _ctx.profileDetails.surname,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.profileDetails.surname = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_ErrorMessage, { name: "lname" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "company",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Company name",
                    modelValue: _ctx.profileDetails.company,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.profileDetails.company = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_ErrorMessage, { name: "company" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_Field, {
                    type: "tel",
                    name: "phone",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Phone number",
                    modelValue: _ctx.profileDetails.contactPhone,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.profileDetails.contactPhone = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "phone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_Field, {
                    type: "text",
                    name: "website",
                    class: "form-control form-control-lg form-control-solid",
                    placeholder: "Company website",
                    modelValue: _ctx.profileDetails.companySite,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.profileDetails.companySite = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "country",
                    class: "form-select form-select-solid form-select-lg fw-bold",
                    modelValue: _ctx.profileDetails.country,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.profileDetails.country = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41,
                      _hoisted_42,
                      _hoisted_43,
                      _hoisted_44,
                      _hoisted_45,
                      _hoisted_46,
                      _hoisted_47,
                      _hoisted_48,
                      _hoisted_49,
                      _hoisted_50,
                      _hoisted_51,
                      _hoisted_52,
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      _hoisted_58,
                      _hoisted_59,
                      _hoisted_60,
                      _hoisted_61,
                      _hoisted_62,
                      _hoisted_63,
                      _hoisted_64,
                      _hoisted_65,
                      _hoisted_66,
                      _hoisted_67,
                      _hoisted_68,
                      _hoisted_69,
                      _hoisted_70,
                      _hoisted_71,
                      _hoisted_72,
                      _hoisted_73,
                      _hoisted_74,
                      _hoisted_75,
                      _hoisted_76,
                      _hoisted_77,
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _hoisted_81,
                      _hoisted_82,
                      _hoisted_83,
                      _hoisted_84,
                      _hoisted_85,
                      _hoisted_86,
                      _hoisted_87,
                      _hoisted_88,
                      _hoisted_89,
                      _hoisted_90,
                      _hoisted_91,
                      _hoisted_92,
                      _hoisted_93,
                      _hoisted_94,
                      _hoisted_95,
                      _hoisted_96,
                      _hoisted_97,
                      _hoisted_98,
                      _hoisted_99,
                      _hoisted_100,
                      _hoisted_101,
                      _hoisted_102,
                      _hoisted_103,
                      _hoisted_104,
                      _hoisted_105,
                      _hoisted_106,
                      _hoisted_107,
                      _hoisted_108,
                      _hoisted_109,
                      _hoisted_110,
                      _hoisted_111,
                      _hoisted_112,
                      _hoisted_113,
                      _hoisted_114,
                      _hoisted_115,
                      _hoisted_116,
                      _hoisted_117,
                      _hoisted_118,
                      _hoisted_119,
                      _hoisted_120,
                      _hoisted_121,
                      _hoisted_122,
                      _hoisted_123,
                      _hoisted_124,
                      _hoisted_125,
                      _hoisted_126,
                      _hoisted_127,
                      _hoisted_128,
                      _hoisted_129,
                      _hoisted_130,
                      _hoisted_131,
                      _hoisted_132,
                      _hoisted_133,
                      _hoisted_134,
                      _hoisted_135,
                      _hoisted_136,
                      _hoisted_137,
                      _hoisted_138,
                      _hoisted_139,
                      _hoisted_140,
                      _hoisted_141,
                      _hoisted_142,
                      _hoisted_143,
                      _hoisted_144,
                      _hoisted_145,
                      _hoisted_146,
                      _hoisted_147,
                      _hoisted_148,
                      _hoisted_149,
                      _hoisted_150,
                      _hoisted_151,
                      _hoisted_152,
                      _hoisted_153,
                      _hoisted_154,
                      _hoisted_155,
                      _hoisted_156,
                      _hoisted_157,
                      _hoisted_158,
                      _hoisted_159,
                      _hoisted_160,
                      _hoisted_161,
                      _hoisted_162,
                      _hoisted_163,
                      _hoisted_164,
                      _hoisted_165,
                      _hoisted_166,
                      _hoisted_167,
                      _hoisted_168,
                      _hoisted_169,
                      _hoisted_170,
                      _hoisted_171,
                      _hoisted_172,
                      _hoisted_173,
                      _hoisted_174,
                      _hoisted_175,
                      _hoisted_176,
                      _hoisted_177,
                      _hoisted_178,
                      _hoisted_179,
                      _hoisted_180,
                      _hoisted_181,
                      _hoisted_182,
                      _hoisted_183,
                      _hoisted_184,
                      _hoisted_185,
                      _hoisted_186,
                      _hoisted_187,
                      _hoisted_188,
                      _hoisted_189,
                      _hoisted_190,
                      _hoisted_191,
                      _hoisted_192,
                      _hoisted_193,
                      _hoisted_194,
                      _hoisted_195,
                      _hoisted_196,
                      _hoisted_197,
                      _hoisted_198,
                      _hoisted_199,
                      _hoisted_200,
                      _hoisted_201,
                      _hoisted_202,
                      _hoisted_203,
                      _hoisted_204,
                      _hoisted_205,
                      _hoisted_206,
                      _hoisted_207,
                      _hoisted_208,
                      _hoisted_209,
                      _hoisted_210,
                      _hoisted_211,
                      _hoisted_212,
                      _hoisted_213,
                      _hoisted_214,
                      _hoisted_215,
                      _hoisted_216,
                      _hoisted_217,
                      _hoisted_218,
                      _hoisted_219,
                      _hoisted_220,
                      _hoisted_221,
                      _hoisted_222,
                      _hoisted_223,
                      _hoisted_224,
                      _hoisted_225,
                      _hoisted_226,
                      _hoisted_227,
                      _hoisted_228,
                      _hoisted_229,
                      _hoisted_230,
                      _hoisted_231,
                      _hoisted_232,
                      _hoisted_233,
                      _hoisted_234,
                      _hoisted_235,
                      _hoisted_236,
                      _hoisted_237,
                      _hoisted_238,
                      _hoisted_239,
                      _hoisted_240,
                      _hoisted_241,
                      _hoisted_242,
                      _hoisted_243,
                      _hoisted_244,
                      _hoisted_245,
                      _hoisted_246,
                      _hoisted_247,
                      _hoisted_248,
                      _hoisted_249,
                      _hoisted_250,
                      _hoisted_251,
                      _hoisted_252,
                      _hoisted_253,
                      _hoisted_254,
                      _hoisted_255,
                      _hoisted_256,
                      _hoisted_257,
                      _hoisted_258,
                      _hoisted_259,
                      _hoisted_260,
                      _hoisted_261,
                      _hoisted_262,
                      _hoisted_263,
                      _hoisted_264,
                      _hoisted_265,
                      _hoisted_266,
                      _hoisted_267,
                      _hoisted_268,
                      _hoisted_269,
                      _hoisted_270,
                      _hoisted_271,
                      _hoisted_272,
                      _hoisted_273,
                      _hoisted_274,
                      _hoisted_275,
                      _hoisted_276,
                      _hoisted_277,
                      _hoisted_278,
                      _hoisted_279,
                      _hoisted_280,
                      _hoisted_281,
                      _hoisted_282,
                      _hoisted_283,
                      _hoisted_284,
                      _hoisted_285,
                      _hoisted_286,
                      _hoisted_287
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_288, [
                    _createElementVNode("div", _hoisted_289, [
                      _createVNode(_component_ErrorMessage, { name: "country" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_290, [
                _hoisted_291,
                _createElementVNode("div", _hoisted_292, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "language",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.profileDetails.language,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.profileDetails.language = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_293,
                      _hoisted_294,
                      _hoisted_295,
                      _hoisted_296,
                      _hoisted_297,
                      _hoisted_298,
                      _hoisted_299,
                      _hoisted_300,
                      _hoisted_301,
                      _hoisted_302,
                      _hoisted_303,
                      _hoisted_304,
                      _hoisted_305,
                      _hoisted_306,
                      _hoisted_307,
                      _hoisted_308,
                      _hoisted_309,
                      _hoisted_310,
                      _hoisted_311,
                      _hoisted_312,
                      _hoisted_313,
                      _hoisted_314,
                      _hoisted_315,
                      _hoisted_316,
                      _hoisted_317,
                      _hoisted_318,
                      _hoisted_319,
                      _hoisted_320,
                      _hoisted_321,
                      _hoisted_322,
                      _hoisted_323,
                      _hoisted_324,
                      _hoisted_325,
                      _hoisted_326,
                      _hoisted_327,
                      _hoisted_328,
                      _hoisted_329,
                      _hoisted_330,
                      _hoisted_331,
                      _hoisted_332,
                      _hoisted_333,
                      _hoisted_334,
                      _hoisted_335,
                      _hoisted_336,
                      _hoisted_337,
                      _hoisted_338
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_339, [
                    _createElementVNode("div", _hoisted_340, [
                      _createVNode(_component_ErrorMessage, { name: "language" })
                    ])
                  ]),
                  _hoisted_341
                ])
              ]),
              _createElementVNode("div", _hoisted_342, [
                _hoisted_343,
                _createElementVNode("div", _hoisted_344, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "timezone",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.profileDetails.timezone,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.profileDetails.timezone = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_345,
                      _hoisted_346,
                      _hoisted_347,
                      _hoisted_348,
                      _hoisted_349,
                      _hoisted_350,
                      _hoisted_351,
                      _hoisted_352,
                      _hoisted_353,
                      _hoisted_354,
                      _hoisted_355,
                      _hoisted_356,
                      _hoisted_357,
                      _hoisted_358,
                      _hoisted_359,
                      _hoisted_360,
                      _hoisted_361,
                      _hoisted_362,
                      _hoisted_363,
                      _hoisted_364,
                      _hoisted_365,
                      _hoisted_366,
                      _hoisted_367,
                      _hoisted_368,
                      _hoisted_369,
                      _hoisted_370,
                      _hoisted_371,
                      _hoisted_372,
                      _hoisted_373,
                      _hoisted_374,
                      _hoisted_375,
                      _hoisted_376,
                      _hoisted_377,
                      _hoisted_378,
                      _hoisted_379,
                      _hoisted_380,
                      _hoisted_381,
                      _hoisted_382,
                      _hoisted_383,
                      _hoisted_384,
                      _hoisted_385,
                      _hoisted_386,
                      _hoisted_387,
                      _hoisted_388,
                      _hoisted_389,
                      _hoisted_390,
                      _hoisted_391,
                      _hoisted_392,
                      _hoisted_393,
                      _hoisted_394,
                      _hoisted_395,
                      _hoisted_396,
                      _hoisted_397,
                      _hoisted_398,
                      _hoisted_399,
                      _hoisted_400,
                      _hoisted_401,
                      _hoisted_402,
                      _hoisted_403,
                      _hoisted_404,
                      _hoisted_405,
                      _hoisted_406,
                      _hoisted_407,
                      _hoisted_408,
                      _hoisted_409,
                      _hoisted_410,
                      _hoisted_411,
                      _hoisted_412,
                      _hoisted_413,
                      _hoisted_414,
                      _hoisted_415,
                      _hoisted_416,
                      _hoisted_417,
                      _hoisted_418,
                      _hoisted_419,
                      _hoisted_420,
                      _hoisted_421,
                      _hoisted_422,
                      _hoisted_423,
                      _hoisted_424,
                      _hoisted_425,
                      _hoisted_426,
                      _hoisted_427,
                      _hoisted_428,
                      _hoisted_429,
                      _hoisted_430,
                      _hoisted_431,
                      _hoisted_432,
                      _hoisted_433,
                      _hoisted_434,
                      _hoisted_435,
                      _hoisted_436,
                      _hoisted_437,
                      _hoisted_438,
                      _hoisted_439,
                      _hoisted_440,
                      _hoisted_441,
                      _hoisted_442,
                      _hoisted_443,
                      _hoisted_444,
                      _hoisted_445,
                      _hoisted_446,
                      _hoisted_447,
                      _hoisted_448,
                      _hoisted_449,
                      _hoisted_450,
                      _hoisted_451,
                      _hoisted_452,
                      _hoisted_453,
                      _hoisted_454,
                      _hoisted_455,
                      _hoisted_456,
                      _hoisted_457,
                      _hoisted_458,
                      _hoisted_459,
                      _hoisted_460,
                      _hoisted_461,
                      _hoisted_462,
                      _hoisted_463,
                      _hoisted_464,
                      _hoisted_465,
                      _hoisted_466,
                      _hoisted_467,
                      _hoisted_468,
                      _hoisted_469,
                      _hoisted_470,
                      _hoisted_471,
                      _hoisted_472,
                      _hoisted_473,
                      _hoisted_474,
                      _hoisted_475,
                      _hoisted_476,
                      _hoisted_477,
                      _hoisted_478,
                      _hoisted_479,
                      _hoisted_480,
                      _hoisted_481,
                      _hoisted_482,
                      _hoisted_483,
                      _hoisted_484,
                      _hoisted_485,
                      _hoisted_486,
                      _hoisted_487
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_488, [
                    _createElementVNode("div", _hoisted_489, [
                      _createVNode(_component_ErrorMessage, { name: "timezone" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_490, [
                _hoisted_491,
                _createElementVNode("div", _hoisted_492, [
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "currency",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.profileDetails.currency,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.profileDetails.currency = $event))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_493,
                      _hoisted_494,
                      _hoisted_495,
                      _hoisted_496,
                      _hoisted_497,
                      _hoisted_498,
                      _hoisted_499
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_500, [
                    _createElementVNode("div", _hoisted_501, [
                      _createVNode(_component_ErrorMessage, { name: "currency" })
                    ])
                  ])
                ])
              ]),
              _hoisted_502,
              _hoisted_503
            ]),
            _createElementVNode("div", _hoisted_504, [
              _hoisted_505,
              _createElementVNode("button", _hoisted_506, _hoisted_509, 512)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ]),
    _createElementVNode("div", _hoisted_510, [
      _hoisted_511,
      _createElementVNode("div", _hoisted_512, [
        _createElementVNode("div", _hoisted_513, [
          _createElementVNode("div", _hoisted_514, [
            _createElementVNode("div", {
              id: "kt_signin_email",
              class: _normalizeClass({ 'd-none': _ctx.emailFormDisplay })
            }, _hoisted_517, 2),
            _createElementVNode("div", {
              id: "kt_signin_email_edit",
              class: _normalizeClass([{ 'd-none': !_ctx.emailFormDisplay }, "flex-row-fluid"])
            }, [
              _createVNode(_component_Form, {
                id: "kt_signin_change_email",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateEmail())),
                "validation-schema": _ctx.changeEmail
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_518, [
                    _createElementVNode("div", _hoisted_519, [
                      _createElementVNode("div", _hoisted_520, [
                        _hoisted_521,
                        _createVNode(_component_Field, {
                          type: "email",
                          class: "\n                        form-control form-control-lg form-control-solid\n                        fw-bold\n                        fs-6\n                      ",
                          id: "emailaddress",
                          placeholder: "Email Address",
                          name: "emailaddress",
                          value: "support@keenthemes.com"
                        }),
                        _createElementVNode("div", _hoisted_522, [
                          _createElementVNode("div", _hoisted_523, [
                            _createVNode(_component_ErrorMessage, { name: "emailaddress" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_524, [
                      _createElementVNode("div", _hoisted_525, [
                        _hoisted_526,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "\n                        form-control form-control-lg form-control-solid\n                        fw-bold\n                        fs-6\n                      ",
                          name: "confirmemailpassword",
                          id: "confirmemailpassword"
                        }),
                        _createElementVNode("div", _hoisted_527, [
                          _createElementVNode("div", _hoisted_528, [
                            _createVNode(_component_ErrorMessage, { name: "confirmemailpassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_529, [
                    _createElementVNode("button", _hoisted_530, _hoisted_533, 512),
                    _createElementVNode("button", {
                      id: "kt_signin_cancel",
                      type: "button",
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_email_button",
              class: _normalizeClass([{ 'd-none': _ctx.emailFormDisplay }, "ms-auto"])
            }, [
              _createElementVNode("button", {
                class: "btn btn-light fw-boldest px-6",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emailFormDisplay = !_ctx.emailFormDisplay))
              }, " Change Email ")
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_534, [
            _createElementVNode("div", {
              id: "kt_signin_password",
              class: _normalizeClass({ 'd-none': _ctx.passwordFormDisplay })
            }, _hoisted_537, 2),
            _createElementVNode("div", {
              id: "kt_signin_password_edit",
              class: _normalizeClass(["flex-row-fluid", { 'd-none': !_ctx.passwordFormDisplay }])
            }, [
              _hoisted_538,
              _createVNode(_component_Form, {
                id: "kt_signin_change_password",
                class: "form",
                novalidate: "novalidate",
                onSubmit: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updatePassword())),
                "validation-schema": _ctx.changePassword
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_539, [
                    _createElementVNode("div", _hoisted_540, [
                      _createElementVNode("div", _hoisted_541, [
                        _hoisted_542,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "\n                        form-control form-control-lg form-control-solid\n                        fw-bold\n                        fs-6\n                      ",
                          name: "currentpassword",
                          id: "currentpassword"
                        }),
                        _createElementVNode("div", _hoisted_543, [
                          _createElementVNode("div", _hoisted_544, [
                            _createVNode(_component_ErrorMessage, { name: "currentpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_545, [
                      _createElementVNode("div", _hoisted_546, [
                        _hoisted_547,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "\n                        form-control form-control-lg form-control-solid\n                        fw-bold\n                        fs-6\n                      ",
                          name: "newpassword",
                          id: "newpassword"
                        }),
                        _createElementVNode("div", _hoisted_548, [
                          _createElementVNode("div", _hoisted_549, [
                            _createVNode(_component_ErrorMessage, { name: "newpassword" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_550, [
                      _createElementVNode("div", _hoisted_551, [
                        _hoisted_552,
                        _createVNode(_component_Field, {
                          type: "password",
                          class: "\n                        form-control form-control-lg form-control-solid\n                        fw-bold\n                        fs-6\n                      ",
                          name: "confirmpassword",
                          id: "confirmpassword"
                        }),
                        _createElementVNode("div", _hoisted_553, [
                          _createElementVNode("div", _hoisted_554, [
                            _createVNode(_component_ErrorMessage, { name: "confirmpassword" })
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_555, [
                    _createElementVNode("button", _hoisted_556, _hoisted_559, 512),
                    _createElementVNode("button", {
                      id: "kt_password_cancel",
                      type: "button",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                      class: "btn btn-color-gray-400 btn-active-light-primary px-6"
                    }, " Cancel ")
                  ])
                ]),
                _: 1
              }, 8, ["validation-schema"])
            ], 2),
            _createElementVNode("div", {
              id: "kt_signin_password_button",
              class: _normalizeClass(["ms-auto", { 'd-none': _ctx.passwordFormDisplay }])
            }, [
              _createElementVNode("button", {
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.passwordFormDisplay = !_ctx.passwordFormDisplay)),
                class: "btn btn-light fw-boldest"
              }, " Reset Password ")
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_560, [
      _hoisted_561,
      _createElementVNode("div", _hoisted_562, [
        _createElementVNode("div", _hoisted_563, [
          _createElementVNode("div", _hoisted_564, [
            _createElementVNode("span", _hoisted_565, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/art/art006.svg" })
            ]),
            _hoisted_566
          ]),
          _hoisted_567
        ]),
        _createElementVNode("div", _hoisted_568, [
          _hoisted_569,
          _createElementVNode("button", {
            ref: "submitButton2",
            class: "btn btn-primary",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveChanges2()))
          }, _hoisted_572, 512)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_573, [
      _hoisted_574,
      _createElementVNode("div", _hoisted_575, [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.saveChanges3()), ["prevent"]))
        }, [
          _hoisted_576,
          _createElementVNode("div", _hoisted_577, [
            _hoisted_578,
            _createElementVNode("button", _hoisted_579, _hoisted_582, 512)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_583, [
      _hoisted_584,
      _createElementVNode("div", _hoisted_585, [
        _createElementVNode("form", {
          class: "form",
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.saveChanges4()), ["prevent"]))
        }, [
          _hoisted_586,
          _createElementVNode("div", _hoisted_587, [
            _hoisted_588,
            _createElementVNode("button", _hoisted_589, _hoisted_592, 512)
          ])
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_593, [
      _hoisted_594,
      _createElementVNode("div", _hoisted_595, [
        _createElementVNode("form", {
          id: "kt_account_deactivate_form",
          class: "form",
          onSubmit: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.deactivateAccount()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_596, [
            _createElementVNode("div", _hoisted_597, [
              _createElementVNode("span", _hoisted_598, [
                _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
              ]),
              _hoisted_599
            ]),
            _hoisted_600
          ]),
          _createElementVNode("div", _hoisted_601, [
            _createElementVNode("button", _hoisted_602, _hoisted_605, 512)
          ])
        ], 32)
      ])
    ])
  ], 64))
}